import { IGetActionLogsDTO, IGetActionLogsResponse, getLogsEndpoints } from '@/models/logs.model';
import { ApiResponse, httpClient } from '@/utils';

class LogsAPI {
  static getActionLogs({ entityType, id, ...params }: IGetActionLogsDTO): ApiResponse<IGetActionLogsResponse> {
    const { GET_ACTION_LOGS } = getLogsEndpoints({ id, entityType });
    return httpClient.get<IGetActionLogsResponse>(GET_ACTION_LOGS, { params });
  }
}

export default LogsAPI;
